import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

import Header from '@/components/Header'
import Product from '@/Product'
import ProductTwo from '@/ProductTwo'
import ProductDetail from '@/components/ProductDetail'
import ProductTwoDetail from '@/components/ProductTwoDetail'
import Home from '@/Home'
import About from '@/About'
import Concat from '@/Concat'
import DataInfo from '@/DataInfo'
import News from '@/News'
import NewsDetail from '@/components/NewsDetail'
import Video from '@/Video'
import VideoDetail from '@/components/VideoDetail'
import App from '@/App'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/header',
      name: 'Header',
      component: Header
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/home',
      name: 'Home1',
      component: Home
    },
    {
      path: '/news',
      name: 'News',
      component: News
    },
    {
      path: '/newsdetail/:id',
      name: 'NewsDetail',
      component: NewsDetail
    },
    {
      path: '/video',
      name: 'Video',
      component: Video
    },
    {
      path: '/videodetail/:id',
      name: 'VideoDetail',
      component: VideoDetail
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/concat',
      name: 'Concat',
      component: Concat
    },
    {
      path: '/datainfo/:id',
      name: 'DataInfo',
      component: DataInfo
    },
    
    {
      path: '/product/:id',
      name: 'ProductC',
      component: Product
    },
    {
      path: '/producttwo',
      name: 'ProductTwo',
      component: ProductTwo
    },
    {
      path: '/product/:id/:key',
      name: 'ProductD',
      component: Product
    },
    {
      path: '/product',
      name: 'Product',
      component: Product
    },
    {
      path: '/helloworld',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/productdetail/:id',
      name: 'Productdetail',
      component: ProductDetail
    },
    {
      path: '/producttwodetail/:id',
      name: 'Producttwodetail',
      component: ProductTwoDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js